import { Box, Flex } from '@/ui';
import { ACCENT, BAR } from './constants';

type Props = {
  // Rows of month cards. Every month-card layout is three cards across, so the
  // row count is what tells the 3/6/12-box variants apart: 1, 2, and 4 rows.
  rows: 1 | 2 | 4;
};

// A grid of month cards, each an outlined card with a filled label band. Larger
// cards fit a short stack of event rows; the 12-box cards are too small for them.
export const MonthCardsThumbnail = ({ rows }: Props) => {
  const eventRows = rows === 1 ? 3 : rows === 2 ? 2 : 0;
  const bandHeight = rows === 1 ? '7px' : rows === 2 ? '4px' : '3px';

  return (
    <Flex direction="column" gap="4px" h="full" w="full">
      {Array.from({ length: rows }).map((_, row) => (
        <Flex flex={1} gap="4px" key={row}>
          {[0, 1, 2].map((card) => (
            <Flex
              border="1px solid"
              borderColor={BAR}
              borderRadius="2px"
              direction="column"
              flex={1}
              key={card}
              overflow="hidden"
            >
              <Box bg={ACCENT} flexShrink={0} h={bandHeight} opacity={0.7} />
              {eventRows > 0 && (
                <Flex direction="column" gap="2px" p="3px">
                  {Array.from({ length: eventRows }).map((_, line) => (
                    <Box bg={BAR} borderRadius="1px" h="2px" key={line} />
                  ))}
                </Flex>
              )}
            </Flex>
          ))}
        </Flex>
      ))}
    </Flex>
  );
};
